import { gql } from '@apollo/client';

const MUTATION = gql`
  mutation CreateRefund($orderId: Int!, $paymentId: Int!, $amount: Int!, $type: String!, $note: String) {
    createRefund(input: { orderId: $orderId, paymentId: $paymentId, amount: $amount, type: $type, note: $note }) {
      id
      amount
      status
      paymentId
    }
  }
`;

export default MUTATION;
